var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReciever(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-76 -21)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#23D4FF",
    d: "M96.7 30c.166 0 .3.134.3.3v5.4c0 .166-.134.3-.3.3h-1.5v.9h-3V36h-8.4v.9h-3V36h-1.5c-.166 0-.3-.134-.3-.3v-5.4c0-.166.134-.3.3-.3zm-13.5 6h-1.8v.3h1.8V36zm11.4 0h-1.8v.3h1.8V36zm1.8-5.4H79.6v4.8h16.8v-4.8zm-.3.3v4.2H79.9v-4.2h16.2zm-.6.6h-15v3h15v-3zm-13.5.6c.497 0 .9.403.9.9s-.403.9-.9.9-.9-.403-.9-.9.403-.9.9-.9zm12.6 0c.166 0 .3.134.3.3v1.2c0 .166-.134.3-.3.3h-7.8c-.166 0-.3-.134-.3-.3v-1.2c0-.166.134-.3.3-.3zm-12.6.6c-.166 0-.3.134-.3.3 0 .166.134.3.3.3.166 0 .3-.134.3-.3 0-.166-.134-.3-.3-.3zm12.3 0h-7.2v.6h7.2v-.6zm-10.2 0v.6h-.6v-.6h.6zm.9 0v.6h-.6v-.6h.6zm.9 0v.6h-.6v-.6h.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReciever);
export default __webpack_public_path__ + "static/media/reciever.291968eb48fce3cb6b8ff74123ad3797.svg";
export { ForwardRef as ReactComponent };